import { Stack, SvgIcon, Typography } from "@mui/material";
import CheckRectangular from "@assets/illustrations/check_rectangular_l18.svg?react";
import { DEFAULT_TITLE_FONT_SIZE } from "@styles/common-styles";
import { Dialog } from "@flat-ui";

interface Props {
  /** Callback to close the dialog */
  onClose: () => void;
}

/**
 * Render a dialog to show the success message after the user has requested a quote.
 */
export function QuoteSuccessDialog({ onClose }: Props): JSX.Element {
  return (
    <Dialog
      open={true}
      title=" "
      size="l"
      onClose={onClose}
      onConfirm={onClose}
      confirmText="Ok"
    >
      <Typography
        sx={{
          fontSize: "32px",
          textAlign: "center",
          width: "100%",
          whiteSpace: "pre-line",
        }}
      >
        Thank you,{"\n"}your request has been sent.
      </Typography>
      <Stack
        sx={{
          alignItems: "center",
          py: "52px",
          width: "100%",
        }}
      >
        <SvgIcon
          inheritViewBox={true}
          component={CheckRectangular}
          sx={{
            width: "84px",
            height: "84px",
          }}
        />
      </Stack>
      <Typography
        sx={{
          fontSize: DEFAULT_TITLE_FONT_SIZE,
          textAlign: "center",
          width: "100%",
        }}
      >
        We'll provide the details within 1-2 business days.
      </Typography>
    </Dialog>
  );
}
